export default "__VITE_ASSET__MiuO0srz__"